import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import CustomButton from 'styles/buttonStyled';

const PageNotFound = () => {
  const history = useHistory();
  return (
    <Container>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: 900, textAlign: 'center' }}>
            <div className="four_zero_four_bg">
              <h1 style={{ fontSize: 80, textAlign: 'center' }}>404</h1>
            </div>
            <div className="contant_box_404">
              <div style={{ fontSize: 30 }}>Look like you're lost !!!!!!!!!!@</div>
              <div style={{ fontSize: 15 }}>the page you are looking for not avaible!</div>
              <CustomButton
                style={{ height: 40, marginTop: 30, fontSize: 16 }}
                onClick={() => history.replace('/')}
              >
                Go to homepage
              </CustomButton>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PageNotFound;

export const Container = styled.div`
  padding: 40px 0;
  background-color: white;

  .page_404 {
    padding: 40px 0;
    /* background: #fff; */
    font-family: 'Arvo', serif;
  }

  .page_404 img {
    width: 100%;
  }

  .four_zero_four_bg {
    background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
    height: 400px;
    background-position: center;
  }

  .link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
  }
  .contant_box_404 {
    margin-top: -50px;
    /* display: 'flex';
    flex-direction: column;
    justify-content: center;
    align-items: center; */
  }
`;
